module.exports = __webpack_public_path__ + "img/Bodice-Back-Jc-Kj-La.3b12c0a7.png";